/**
 * 秒杀活动是否处于进行中（与小程序详情 / 倒计时口径一致）
 * @param {object} activity
 * @param {number} nowSec Unix 秒
 */

function resolveNowSec(nowSec) {
  const n = Number(nowSec);
  return Number.isFinite(n) ? n : Math.floor(Date.now() / 1000);
}

/** 将接口时间字段统一为 Unix 秒 */
function toUnixSec(v) {
  if (v == null || v === '') return 0;
  const n = Number(v);
  if (Number.isFinite(n) && n > 0) {
    return n > 1e12 ? Math.floor(n / 1000) : Math.floor(n);
  }
  const ms = Date.parse(String(v).replace(/-/g, '/'));
  return Number.isFinite(ms) ? Math.floor(ms / 1000) : 0;
}

/** 活动是否已明确结束（仅在有有效 end_time 时判定） */
export function isSeckillActivityEnded(activity, nowSec) {
  if (!activity || typeof activity !== 'object') return false;
  const now = resolveNowSec(nowSec);
  const end = toUnixSec(activity.end_time);
  return !!(end && end <= now);
}

export function isSeckillActivityLive(activity, nowSec) {
  if (!activity || typeof activity !== 'object') return false;
  const now = resolveNowSec(nowSec);
  const end = toUnixSec(activity.end_time);
  const start = toUnixSec(activity.start_time);

  if (isSeckillActivityEnded(activity, now)) return false;

  if (start && start > now) {
    const st = activity.status;
    const stText = String(activity.status_text || '');
    return (
      st === 'ing' ||
      st === 'up' ||
      st === 'pre_head' ||
      st === 'not_start' ||
      /进行中|未开始|即将开始|预热/.test(stText)
    );
  }

  if (!end) {
    const st = activity.status;
    return st === 'ing' || st === 'pre_head' || st === 'not_start' || st === 'up';
  }

  return true;
}
